import React, { useEffect } from "react";

import Footer from "../../Components/Footer/footer.component";
import { Landing } from "../../Components/Animation/animation.component";
import "./login.styles.scss";
import SignIn from "../../Components/Sign-in/sign-in.component";
import Header from "../../Components/Header/header.component";

const Login = ({ title }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
  return (
    <div className="Home">
      <Header />
      <span className="Title">Welcome to Assessment Portal</span>
      <div className="sign-up">
        <SignIn />
      </div>
      <div
        className="LoginFooter"
        style={{
          width: "70vw",
          display: "flex",
          position: "relative",
          top: "50vh",
        }}
      >
        <Landing />
      </div>
      <Footer />
    </div>
  );
};
export default Login;
